import React from 'react';
import { DeviceSelectModal } from '../shared/components/DeviceSelectModal/DeviceSelectModal';
import { useUIState } from '../shared/contexts/UIStateProvider';
import { RecordingModal } from './RecordingModal';
import { LinkModal } from './LinkModal';
import { LeaveModal } from './LeaveModal';

export const Modals = () => {
	const { modals } = useUIState();

	return (
		<>
			<DeviceSelectModal />
			<RecordingModal />
			<LinkModal />
			<LeaveModal />
			{modals.map((ModalComponent: any) => (
				<ModalComponent key={ModalComponent.name} />
			))}
		</>
	);
};
